import { useTranslation } from 'react-i18next';

const ClientWelcome = ({ agency }) => {
    const { t, i18n } = useTranslation();

    if (!agency) return null;

    return (
        <div className="mb-8 bg-bg-card border border-gold/10 rounded-xl shadow-lg p-8 text-text relative overflow-hidden">
            <div className="absolute top-0 right-0 w-64 h-64 bg-gold/5 rounded-full blur-3xl -mr-16 -mt-16 pointer-events-none"></div>
            <div className="flex flex-col sm:flex-row items-center gap-6 text-center sm:text-left">
                {agency.logo && (
                    <img src={`${import.meta.env.VITE_API_URL || ''}/static/agency_logos/${agency.logo}`} alt={i18n.language === 'ar' ? (agency.name_ar || agency.name) : (agency.name_en || agency.name)} className="h-20 w-20 object-contain" />
                )}
                <div>
                    <h2 className="text-3xl font-bold mb-2 text-text">{t('welcome', { name: i18n.language === 'ar' ? (agency.name_ar || agency.name) : (agency.name_en || agency.name) })}</h2>
                    <p className="text-textMuted">{t('subtitle')}</p>
                </div>
            </div>
        </div>
    );
};

export default ClientWelcome;
